<template>
  <div class="upload-file-button-wrap">
    <WsText001
      v-if="title"
      h6
      class="mb-10"
    >
      {{ title }}
    </WsText001>
    <div
      class="upload-file-button_content"
      @click="$_handleUploadBtnClick()"
    >
      <div
        v-if="text"
        class="upload-text"
      >
        <i class="icon-attachment" />
        <p>{{ textLabel ? $t(textLabel) : $t('附件') }}<span v-if="num">({{ num }})</span></p>
      </div>
      <div
        v-else
        class="upload-file-button upload-file"
      >
        <i class="icon-cloud-upload" />
        <p>{{ textLabel ? $t(textLabel) : $t('上傳') }}</p>
      </div>
      <input
        ref="fileInput"
        :multiple="multiple"
        type="file"
        @change="$_fileChange()"
      >
    </div>
    <p
      :class="{error:error}"
      class="pload-file-button_remind-text"
    >
      {{ _remindText }}
    </p>
  </div>
</template>
<script>
export default {
  name: "UploadFileButton",
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    title: {
      type: String,
      default: "",
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    text: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    textLabel: {
      type: String,
      default: "",
    },
    uploadUrl: {
      type: String,
      default: "",
    },
    remindText: {
      type: String,
      default: "",
    },
    factory: {
      type: String,
    },
    url: {
      type: String,
    },
    moduleName :{
      type: String,
    },
  },
  data: () => ({
    isloading: false,
    C_files: [],
    error: false,
  }),
  computed: {
    _remindText() {
      return this.remindText !== ''
        ? this.$t(this.remindText)
        : `${this.$t('檔案大小限制')} ≤ 30 MB`;
    }
  },
  watch: {
    C_files: {
      handler() {
        this.$_emitValue();
      },
      deep: true,
    },
    value() {
      this.C_files = this.value;
    },
  },
  mounted() {
    this.$_valueSet();
  },
  methods: {
    $_handleUploadBtnClick() {
      this.$refs.fileInput.value = null;
      this.$refs.fileInput.click();
    },
    $_fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async $_fileChange() {
      const files = this.$refs.fileInput.files;
      //limit:30mb
      const fileLimit = 30 * 1024 * 1024;
      for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
        const file = files[fileIndex];
        if (file.size > fileLimit) {
          this.error = true;
          if (!this.remindText) {
            alert(this.$t(`檔案尺寸超過{number}MB`,{number:'30'}));
          }
          return;
        }
        if (this.multiple) {
          this.C_files.push({
            percent: 0,
            isloading: true,
            file: file,
            url: file.name,
            fileIndex: fileIndex,
          });
        } else {
          this.C_files = [
            {
              percent: 0,
              isloading: true,
              file: file,
              url: file.name,
              fileIndex: fileIndex,
            },
          ];
        }
      }
      const factory = this.factory ? `/factory/${this.factory}` : "";
      this.C_files.forEach((C_file) => {
        if (!C_file.isloading) {
          return;
        }
        const file = C_file.file;
        let url = this.url
          ? `/${this.url}/${file.name}?factory=${this.factory}`
          : `${factory}${this.uploadUrl}${file.name}`;
        if (this.moduleName) {
          url += `&module=${this.moduleName}`
        }
        this.$axios
          .put(url, file, {
            onUploadProgress: (progressEvent) =>
              this.$_handleUploadProgress(progressEvent, C_file),
          })
          .then((res) => {
            if (res.data.data) {
              C_file.url = res.data.data.source_url
              C_file.file = res.data.data
            } else {
              C_file.url = res.data.signed_url;
            }
            C_file.percent = 0;
            C_file.isloading = false;
          });
      }, 0);
    },
    $_valueSet() {
      if (this.value) {
        this.value.forEach((valueItem) => {
          this.C_files.push({
            url: valueItem.url,
          });
        });
      }
    },
    $_emitValue() {
      this.$emit("input", this.C_files);
    },
    $_handleUploadProgress(progressEvent, target) {
      target.percent = Math.round(
        (progressEvent.loaded / progressEvent.total) * 100
      );
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/component/upload-file-button";
</style>